import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // 🔥 ADD THIS

const firebaseConfig = {
  apiKey: "AIzaSyDjlj_WlUAqDeGKiw_g4n2t_sx56iBdXNk",
  authDomain: "skillclash-7861.firebaseapp.com",
  projectId: "skillclash-7861",
  storageBucket: "skillclash-7861.firebasestorage.app",
  messagingSenderId: "823932694040",
  appId: "1:823932694040:web:53dbdb6e37d1af0626dd6d",
  measurementId: "G-BHDC9LHMRS"
};

// 🔥 INIT
const app = initializeApp(firebaseConfig);

// ✅ EXPORT BOTH
export const db = getFirestore(app);
export const auth = getAuth(app); // 🔥 IMPORTANT